import React, { useState, useRef, MouseEvent } from 'react';
import { useUid } from '../utils/useUid';
import { IArticleVideo } from './ICustomerService';
import VideoModal from './VideoModal';

export interface FaqArticleItemVideoProps {
  VideoCommonTitle: string;
  video: IArticleVideo;
}

const FaqArticleItemVideo = ({ VideoCommonTitle, video }: FaqArticleItemVideoProps) => {
  const [ showVideoModal, setShowVideoModal ] = useState(false);
  const uid = useUid();
  const launchDialog = useRef<HTMLButtonElement | null>(null);

  const showTheVideoModal = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const scrollY = window.scrollY;
    setShowVideoModal(true);
    launchDialog.current.setAttribute("aria-expanded", "true");
    document.body.style.width = "100%";
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    setTimeout(() => document.getElementById(`customer-service-faq-video-modal-heading-${uid}`).focus(), 10);
  }

  const closeTheVideoModal = () => {
    const scrollY = document.body.style.top;
    document.body.style.width = "";
    document.body.style.position = "";
    document.body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
    setShowVideoModal(false);
    launchDialog.current.setAttribute("aria-expanded", "false");
    setTimeout(() => document.getElementById(`customer-service-launch-video-button-${uid}`).focus(), 10);
  }

  return (
    <div className="customer-service-faq__faq-article__video-grid__video">
      <button
        className="customer-service-faq__faq-article__video-grid__video-button"
        id={`customer-service-launch-video-button-${uid}`}
        ref={launchDialog}
        onClick={(e) => showTheVideoModal(e)}
        aria-haspopup="true"
        aria-controls={`customer-service-faq-video-modal-dialog-${uid}`}
        aria-expanded="false"
      >
        <img
          src={video.ImageUrl}
          alt={video.SubTitle}
          className="customer-service-faq__faq-article__video-grid__video-item"
        />
        <span className="customer-service-faq__faq-article__video-grid__video-subtitle">{video.SubTitle}</span>
      </button>
      {showVideoModal && (<VideoModal 
        id={uid}
        show={showVideoModal}
        onCloseClick={closeTheVideoModal}
        VideoCommonTitle={VideoCommonTitle}
        subtitle={video.SubTitle}
        thumbnail={video.ImageUrl}
        url={video.VideoUrl}
      />)}
    </div>
  );
};

export default FaqArticleItemVideo;
